import { useState } from "react";
import { Maximize2, RotateCcw, ZoomIn, ZoomOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function ZoomableImage({ src, alt, className = "", dialogLabel = "Image", ...buttonProps }) {
  const [open, setOpen] = useState(false);
  const [zoom, setZoom] = useState(1);

  const reset = () => setZoom(1);

  return (
    <>
      <button
        type="button"
        onClick={() => { reset(); setOpen(true); }}
        className={`group relative block overflow-hidden ${className}`}
        title={`Agrandir ${alt}`}
        {...buttonProps}
      >
        <img src={src} alt={alt} className="h-full w-full object-cover transition duration-200 group-hover:scale-105" />
        <span className="absolute inset-0 flex items-center justify-center bg-black/0 text-white opacity-0 transition group-hover:bg-black/35 group-hover:opacity-100">
          <Maximize2 size={22} />
        </span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex h-[90dvh] w-[calc(100vw-1rem)] max-w-6xl flex-col overflow-hidden bg-[#121716] p-0 text-white sm:w-[92vw]">
          <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-3">
            <p className="min-w-0 truncate text-sm font-semibold">{dialogLabel}</p>
            <div className="flex items-center gap-1">
              <Button type="button" size="icon" variant="ghost" className="text-white hover:bg-white/10 hover:text-white" onClick={() => setZoom((value) => Math.max(0.75, Number((value - 0.25).toFixed(2))))} title="Réduire">
                <ZoomOut size={18} />
              </Button>
              <span className="w-12 text-center text-xs text-white/75">{Math.round(zoom * 100)}%</span>
              <Button type="button" size="icon" variant="ghost" className="text-white hover:bg-white/10 hover:text-white" onClick={() => setZoom((value) => Math.min(4, Number((value + 0.25).toFixed(2))))} title="Agrandir">
                <ZoomIn size={18} />
              </Button>
              <Button type="button" size="icon" variant="ghost" className="text-white hover:bg-white/10 hover:text-white" onClick={reset} title="Réinitialiser le zoom">
                <RotateCcw size={17} />
              </Button>
            </div>
          </div>
          <div className="flex-1 overflow-auto p-4">
            <div className="flex min-h-full min-w-full items-center justify-center">
              <img
                src={src}
                alt={alt}
                className="max-w-none rounded-sm shadow-2xl"
                style={{ width: `${zoom * 100}%`, maxWidth: "none" }}
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
